import { useAppStore } from '@/stores/app';
import type { Org } from '@/types';
import RadioGroup from '@nautilusbio/nb-design-system/RadioGroup';
import React, { type FC, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

const SelectionCellRenderer: FC<{ data: Org }> = ({ data }) => {
  const { t } = useTranslation('orgs');

  const { selectedOrganization, setSelectedOrganization, setSelectedOrgId } = useAppStore(
    useShallow(state => ({
      selectedOrganization: state.selectedOrganization,
      setSelectedOrganization: state.setSelectedOrganization,
      setSelectedOrgId: state.setSelectedOrgId,
    })),
  );

  const isSelected = selectedOrganization?.id === data.id;

  const handleChange = useCallback(() => {
    setSelectedOrganization(data);
    setSelectedOrgId(data.id);
    toast.success(t('org_switched_success', { name: data.name }));
  }, [data, setSelectedOrganization, setSelectedOrgId, t]);

  return (
    <RadioGroup
      aria-label={t('select_organization', { name: data.name })}
      data-testid={`org-select-${data.id}`}
      id={`org-select-${data.id}`}
      label=""
      onChange={handleChange}
      options={[{ children: '', value: data.id }]}
      size="sm"
      value={isSelected ? data.id : ''}
    />
  );
};

export default memo(SelectionCellRenderer);
